window.AmbitionRuntime.register('products', context => {
  const page = document.querySelector('.ambition-page');
  if (!page) return;
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const assetCache = new Map();
  function prepareAsset(path) {
    if (!assetCache.has(path)) assetCache.set(path, new Promise((resolve, reject) => {
      const image = new Image();
      image.onload = () => image.decode().then(resolve, resolve);
      image.onerror = () => { assetCache.delete(path); reject(new Error('Falha ao carregar a foto.')); };
      image.src = path;
    }));
    return assetCache.get(path);
  }
  function colorGallery(root, views, productName) {
    const slots = [root.querySelector('.editorial'), root.querySelector('.product-image')];
    if (!slots.every(Boolean) || !views.length) return;
    const pictures = slots.map(slot => slot.querySelector('picture'));
    if (!pictures.every(Boolean)) return;
    const buttons = [...root.querySelectorAll('[data-color]')];
    const device = () => matchMedia('(max-width:700px)').matches ? 'mobile' : 'desktop';
    const selected = Math.max(0, buttons.findIndex(button => button.getAttribute('aria-pressed') === 'true'));
    let current = Math.min(selected, views.length - 1), requested = current, requestId = 0;
    const layers = new Set();
    root.dataset.activeColor = views[current].label;
    const cta = root.querySelector('[data-gallery-cta]') || root.querySelector('.details > .cta');
    const defaultURL = cta?.dataset.defaultUrl || cta?.getAttribute('href');
    if (cta && defaultURL) cta.dataset.defaultUrl = defaultURL;
    function syncCTA(index) { if (cta) cta.setAttribute('href', views[index].url || defaultURL || '#section9-scroll'); }
    syncCTA(current);
    const colors = root.querySelector('.colors');
    colors?.setAttribute('role', 'group');
    colors?.setAttribute('aria-label', 'Cores de ' + productName);
    const status = document.createElement('p');
    status.className = 'visually-hidden';
    status.setAttribute('role', 'status');
    root.querySelector('.details').append(status);
    function finishLayers() {
      layers.forEach(({ animation, clone }) => { animation.cancel(); clone.remove(); });
      layers.clear();
    }
    async function show(index) {
      index = (index + views.length) % views.length;
      requested = index;
      const id = ++requestId, activeDevice = device();
      root.setAttribute('aria-busy', 'true');
      try { await Promise.all(views[index][activeDevice].map(prepareAsset)); }
      catch (error) {
        if (id === requestId && !context.signal.aborted) {
          requested = current;
          root.removeAttribute('aria-busy');
          status.textContent = 'Não foi possível carregar esta cor. Tente novamente.';
        }
        return;
      }
      if (id !== requestId || context.signal.aborted || !root.isConnected) return;
      if (activeDevice !== device()) return show(index);
      finishLayers();
      const previous = index !== current && !motion.matches ? pictures.map(picture => {
        const clone = picture.cloneNode(true);
        clone.classList.add('gallery-previous');
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelector('img').alt = '';
        picture.parentElement.append(clone);
        return clone;
      }) : [];
      pictures.forEach((picture, slot) => {
        let source = picture.querySelector('source');
        if (!source) { source = document.createElement('source'); source.media = '(max-width:700px)'; picture.prepend(source); }
        source.srcset = views[index].mobile[slot];
        const image = picture.querySelector('img');
        image.removeAttribute('srcset');
        image.src = views[index].desktop[slot];
        image.alt = productName + ' ' + views[index].label + (slot === 0 ? ' em uso' : '');
      });
      current = index;
      syncCTA(index);
      buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
      root.dataset.activeColor = views[index].label;
      root.removeAttribute('aria-busy');
      status.textContent = '';
      previous.forEach(clone => {
        const animation = clone.animate({ opacity: [1, 0] }, { duration: 220, easing: 'ease-out' });
        const layer = { animation, clone };
        layers.add(layer);
        const remove = () => { clone.remove(); layers.delete(layer); };
        animation.finished.then(remove, remove);
      });
    }
    buttons.forEach((button, index) => {
      context.listen(button, 'click', () => show(index));
      context.listen(button, 'keydown', event => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const next = (index + (event.key === 'ArrowLeft' ? -1 : 1) + views.length) % views.length;
        buttons[next].focus();
        show(next);
      });
    });
    slots.forEach(slot => {
      let start = null;
      context.listen(slot, 'pointerdown', event => {
        if (!event.isPrimary || event.button !== 0) return;
        start = { x: event.clientX, y: event.clientY, id: event.pointerId };
        slot.setPointerCapture(event.pointerId);
      });
      context.listen(slot, 'pointerup', event => {
        if (start && start.id === event.pointerId) {
          const dx = event.clientX - start.x, dy = event.clientY - start.y;
          if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy)) show(requested + (dx < 0 ? 1 : -1));
        }
        start = null;
      });
      ['pointercancel', 'lostpointercapture'].forEach(name => context.listen(slot, name, () => { start = null; }));
      context.listen(slot, 'dragstart', event => event.preventDefault());
    });
    context.listen(motion, 'change', () => { if (motion.matches) finishLayers(); });
    const observer = new IntersectionObserver((entries, observer) => {
      if (!entries.some(entry => entry.isIntersecting)) return;
      views[(current + 1) % views.length][device()].forEach(path => prepareAsset(path).catch(() => {}));
      observer.disconnect();
    }, { rootMargin: '200px' });
    observer.observe(root);
    context.listen(document, 'shopify:block:select', event => {
      const button = buttons.find(button => button === event.target || button.contains(event.target) || (() => {
        try { return JSON.parse(button.getAttribute('data-shopify-editor-block') || '{}').id === event.detail?.blockId; } catch { return false; }
      })());
      if (button) show(buttons.indexOf(button));
    });
    context.cleanup(() => { requestId += 1; observer.disconnect(); finishLayers(); status.remove(); root.removeAttribute('aria-busy'); });
  }
  page.querySelectorAll('[data-gallery]').forEach(root => {
    const script = root.querySelector('script[data-ambition-gallery]');
    if (!script) return;
    try {
      const data = JSON.parse(script.textContent);
      const views = (data.views || []).filter(view => Array.isArray(view.desktop) && view.desktop.length === 2 && view.desktop.every(Boolean)).map(view => ({ ...view, mobile: Array.isArray(view.mobile) && view.mobile.length === 2 && view.mobile.every(Boolean) ? view.mobile : view.desktop }));
      colorGallery(root, views, data.name || root.dataset.productName || 'Ambition');
    } catch (error) { console.error('[Ambition gallery]', error); }
  });
  function collection(section) {
    const track = section.querySelector('.loop-track');
    const viewport = section.querySelector('.loop-window');
    if (!track || !viewport) return;
    const products = [...track.children].filter(card => !card.hasAttribute('data-clone'));
    if (!products.length) return;
    const originals = products.map(card => card.cloneNode(true));
    const help = section.querySelector('[data-collection-help]');
    const originalHelp = help?.textContent;
    const originalShortcuts = section.getAttribute('aria-keyshortcuts');
    const originalTransform = track.style.transform;
    const originalSnap = viewport.style.scrollSnapType;
    const originalBehavior = viewport.style.scrollBehavior;
    let looping = false, visible = false, hovered = false, focused = false, drag = null;
    let cycle = 0, position = 0, frame = 0, previousTime = 0, velocity = 0, tween = null;
    let holdUntil = 0, wakeTimer = 0, settleTimer = 0, skipClickUntil = 0, geometry = '', speed = .024;
    const stride = () => products[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(track).gap) || 0);
    const modulo = (value, size) => ((value % size) + size) % size;
    const maximum = () => Math.max(0, viewport.scrollWidth - viewport.clientWidth);
    const finite = value => Math.max(0, Math.min(maximum(), value));
    function paint() {
      if (!looping || !cycle) return;
      viewport.scrollLeft = 0;
      const offset = cycle + modulo(position - cycle, cycle);
      track.style.transform = `translate3d(${-offset}px, 0, 0)`;
    }
    function autoplay() {
      return looping && visible && !hovered && !focused && !drag && !document.hidden && performance.now() >= holdUntil;
    }
    function active() { return looping && visible && !document.hidden && (autoplay() || Math.abs(velocity) > 1 || tween); }
    function sync() {
      section.dataset.paused = String(!autoplay());
      if (active() && !frame) frame = requestAnimationFrame(animate);
      if (!active()) { cancelAnimationFrame(frame); frame = 0; previousTime = 0; }
    }
    function hold(milliseconds = 1200) {
      holdUntil = performance.now() + milliseconds;
      clearTimeout(wakeTimer);
      wakeTimer = setTimeout(sync, milliseconds + 10);
    }
    function animate(time) {
      frame = 0;
      if (!active()) { previousTime = 0; return; }
      const delta = previousTime ? Math.min(time - previousTime, 40) : 0;
      previousTime = time;
      if (tween) {
        const progress = Math.min(1, (time - tween.start) / 300);
        position = tween.from + (tween.to - tween.from) * (1 - Math.pow(1 - progress, 3));
        if (progress === 1) tween = null;
      } else if (!drag && Math.abs(velocity) > 1) {
        position += velocity * delta / 1000;
        velocity *= Math.exp(-delta / 180);
        if (Math.abs(velocity) < 1) velocity = 0;
      } else if (autoplay()) {
        position += delta * speed;
      }
      paint(); sync();
    }
    function cloneSet() {
      return originals.map((original, index) => {
        const clone = original.cloneNode(true);
        clone.dataset.clone = String(index);
        clone.setAttribute('aria-hidden', 'true');
        [clone, ...clone.querySelectorAll('[id], [data-shopify-editor-block]')].forEach(element => {
          element.removeAttribute('id'); element.removeAttribute('data-shopify-editor-block');
        });
        clone.querySelectorAll('a, button, input, [tabindex]').forEach(element => { element.tabIndex = -1; });
        return clone;
      });
    }
    function restoreSnap() {
      clearTimeout(settleTimer);
      viewport.style.scrollSnapType = originalSnap;
      viewport.style.scrollBehavior = originalBehavior;
    }
    function release(event) {
      if (!drag || (event?.pointerId != null && event.pointerId !== drag.id)) return;
      const previous = drag; drag = null;
      viewport.classList.remove('dragging');
      if (viewport.hasPointerCapture(previous.id)) viewport.releasePointerCapture(previous.id);
      if (previous.horizontal) {
        skipClickUntil = performance.now() + 250;
        hold();
        if (looping) velocity = performance.now() - previous.time < 100 ? Math.max(-900, Math.min(900, previous.velocity * 1000)) : 0;
        else {
          const projected = finite(viewport.scrollLeft + previous.velocity * 100);
          const stops = [...products.map((_, index) => finite(index * stride())), maximum()];
          const target = stops.reduce((nearest, point) => Math.abs(point - projected) < Math.abs(nearest - projected) ? point : nearest, 0);
          viewport.scrollTo({ left: target, behavior: motion.matches ? 'instant' : 'smooth' });
          settleTimer = setTimeout(restoreSnap, motion.matches ? 0 : 650);
        }
      }
      sync();
    }
    function rebuild() {
      const enabled = products.length > 1 && !motion.matches && !window.Shopify?.designMode;
      const key = [viewport.clientWidth, products[0].getBoundingClientRect().width, getComputedStyle(track).gap, enabled].join(':');
      if (key === geometry) return;
      geometry = key;
      speed = matchMedia('(max-width:700px)').matches ? .018 : .024;
      const phase = looping && cycle ? modulo(position - cycle, cycle) / cycle : viewport.scrollLeft / Math.max(1, stride() * products.length);
      release(); restoreSnap(); cancelAnimationFrame(frame); frame = 0; previousTime = 0; velocity = 0; tween = null;
      track.querySelectorAll('[data-clone]').forEach(clone => clone.remove());
      track.style.transform = originalTransform;
      viewport.scrollLeft = 0;
      looping = enabled;
      section.classList.toggle('is-looping', looping);
      section.dataset.autoplayAvailable = String(looping);
      if (looping) {
        cycle = stride() * products.length;
        track.prepend(...cloneSet());
        const following = Math.ceil(viewport.clientWidth / cycle) + 1;
        for (let index = 0; index < following; index++) track.append(...cloneSet());
        position = cycle + phase * cycle;
        paint();
      } else {
        cycle = 0;
        viewport.scrollLeft = finite(phase * stride() * products.length);
      }
      sync();
    }
    context.listen(viewport, 'pointerenter', event => { if (event.pointerType === 'mouse') { hovered = true; velocity = 0; tween = null; sync(); } });
    context.listen(viewport, 'pointerleave', () => { hovered = false; hold(350); sync(); });
    context.listen(viewport, 'pointerdown', event => {
      if (event.button !== 0 || !event.isPrimary || (!looping && (event.pointerType === 'touch' || maximum() <= 1))) return;
      tween = null; velocity = 0; skipClickUntil = 0; restoreSnap();
      drag = { id: event.pointerId, startX: event.clientX, startY: event.clientY, x: event.clientX, start: looping ? position : viewport.scrollLeft, time: performance.now(), velocity: 0, horizontal: false };
      sync();
    });
    context.listen(window, 'pointermove', event => {
      if (!drag || event.pointerId !== drag.id) return;
      const dx = event.clientX - drag.startX, dy = event.clientY - drag.startY;
      if (!drag.horizontal) {
        if (Math.max(Math.abs(dx), Math.abs(dy)) < 8) return;
        if (Math.abs(dy) >= Math.abs(dx)) { release(event); return; }
        drag.horizontal = true;
        viewport.classList.add('dragging');
        viewport.style.scrollSnapType = 'none'; viewport.style.scrollBehavior = 'auto';
        viewport.setPointerCapture(drag.id);
      }
      event.preventDefault();
      const time = performance.now(), elapsed = Math.max(1, time - drag.time);
      drag.velocity = drag.velocity * .4 + (drag.x - event.clientX) / elapsed * .6;
      drag.x = event.clientX; drag.time = time;
      if (looping) { position = drag.start - dx; paint(); }
      else viewport.scrollLeft = finite(drag.start - dx);
    }, { passive: false });
    ['pointerup', 'pointercancel'].forEach(name => context.listen(window, name, release));
    context.listen(viewport, 'lostpointercapture', release);
    context.listen(window, 'blur', () => { release(); velocity = 0; sync(); });
    context.listen(viewport, 'dragstart', event => event.preventDefault());
    context.listen(viewport, 'mousedown', event => { if (event.target.closest('[data-clone] a')) event.preventDefault(); });
    context.listen(viewport, 'click', event => {
      if (performance.now() < skipClickUntil) { event.preventDefault(); event.stopPropagation(); skipClickUntil = 0; }
    }, { capture: true });
    context.listen(section, 'focusin', event => {
      focused = true; velocity = 0; tween = null;
      const card = event.target.closest('article');
      const index = card?.hasAttribute('data-clone') ? Number(card.dataset.clone) : products.indexOf(card);
      if (looping && index >= 0 && event.target.matches(':focus-visible')) {
        position = cycle + index * stride(); paint();
        if (card.hasAttribute('data-clone')) products[index].querySelector('a, button, [tabindex]')?.focus({ preventScroll: true });
      }
      sync();
    });
    context.listen(section, 'focusout', event => { if (!section.contains(event.relatedTarget)) { focused = false; hold(500); sync(); } });
    context.listen(section, 'keydown', event => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key) || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey || event.target.closest('input, textarea, select, [contenteditable=true]')) return;
      if (!looping && maximum() <= 1) return;
      event.preventDefault(); velocity = 0; restoreSnap();
      const current = looping ? position - cycle : viewport.scrollLeft;
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? (products.length - 1) * stride() : (Math.round(current / stride()) + (event.key === 'ArrowLeft' ? -1 : 1)) * stride();
      if (looping) { tween = { from: position, to: cycle + next, start: performance.now() }; sync(); }
      else viewport.scrollTo({ left: finite(next), behavior: motion.matches ? 'instant' : 'smooth' });
    });
    context.listen(viewport, 'wheel', event => {
      if (!looping || Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
      event.preventDefault(); tween = null; velocity = 0; position += event.deltaX; hold(); paint(); sync();
    }, { passive: false });
    context.listen(document, 'visibilitychange', () => { previousTime = 0; velocity = 0; sync(); });
    context.listen(motion, 'change', rebuild);
    context.listen(document, 'shopify:block:select', event => {
      const index = products.findIndex(card => card === event.target || card.contains(event.target) || (() => {
        try { return JSON.parse(card.getAttribute('data-shopify-editor-block') || '{}').id === event.detail?.blockId; } catch { return false; }
      })());
      if (index >= 0 && !looping) viewport.scrollTo({ left: finite(index * stride()), behavior: 'instant' });
    });
    const intersection = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; previousTime = 0; sync(); });
    intersection.observe(viewport);
    const resizeObserver = new ResizeObserver(rebuild);
    resizeObserver.observe(viewport); products.forEach(product => resizeObserver.observe(product));
    section.classList.add('collection-ready');
    section.setAttribute('aria-keyshortcuts', 'ArrowLeft ArrowRight Home End');
    if (help && (!originalHelp.trim() || originalHelp.trim() === 'Arraste os produtos para navegar. Pelo teclado, use as setas. No desktop, Espaço pausa ou retoma o movimento.')) {
      help.textContent = 'Arraste os produtos para navegar. O movimento para ao passar o mouse ou usar o teclado. Use as setas, Home e End para navegar.';
    }
    rebuild();
    context.cleanup(() => {
      cancelAnimationFrame(frame); clearTimeout(wakeTimer); clearTimeout(settleTimer);
      intersection.disconnect(); resizeObserver.disconnect();
      if (drag && viewport.hasPointerCapture(drag.id)) viewport.releasePointerCapture(drag.id);
      drag = null; restoreSnap();
      track.querySelectorAll('[data-clone]').forEach(clone => clone.remove());
      track.style.transform = originalTransform;
      viewport.classList.remove('dragging');
      section.classList.remove('collection-ready', 'is-looping');
      ['paused', 'autoplayAvailable'].forEach(key => delete section.dataset[key]);
      if (originalShortcuts == null) section.removeAttribute('aria-keyshortcuts'); else section.setAttribute('aria-keyshortcuts', originalShortcuts);
      if (help) help.textContent = originalHelp;
    });
  }
  page.querySelectorAll('.collection').forEach(collection);
});
